import { render, staticRenderFns } from "./UserStatusButton.vue?vue&type=template&id=2fac23ea&scoped=true"
import script from "./UserStatusButton.vue?vue&type=script&lang=js"
export * from "./UserStatusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac23ea",
  null
  
)

export default component.exports